var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"chat-page"},[(_vm.activeConv)?_c('chat-box',{attrs:{"conversation":_vm.activeConv}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }